module.exports = "<div md-whiteframe=\"1\" class=\"content-box text-center\">\n  <h1>{{ \"USERS.INSTALATOR_REGISTRATION_CONFIRM.GREETINGS\" | translate:{name: \"Instalator\"} }}</h1>\n  <p>{{ \"USERS.INSTALATOR_REGISTRATION_CONFIRM.INFO\" | translate }}</p>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/users/instalator/instalator-registration-confirm.html
// module id = 257
// module chunks = 0